import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TaskScheduledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M5.42 19.84V4.08H10.26C10.44 3.28 11.14 2.68 12 2.68C12.86 2.68 13.56 3.28 13.74 4.08H18.58V19.84H5.42ZM6.94 18.32H17.06V5.6H14.88V6.6H9.12V5.6H6.94V18.32ZM9.62 10.2C9.12 10.2 8.7 9.78 8.7 9.28C8.7 8.78 9.12 8.36 9.62 8.36C10.12 8.36 10.54 8.78 10.54 9.28C10.54 9.78 10.12 10.2 9.62 10.2ZM11.34 8.56H14.88V10H11.34V8.56ZM9.62 13.32C9.12 13.32 8.7 12.9 8.7 12.4C8.7 11.9 9.12 11.48 9.62 11.48C10.12 11.48 10.54 11.9 10.54 12.4C10.54 12.9 10.12 13.32 9.62 13.32ZM11.34 11.68H14.88V13.12H11.34V11.68ZM9.62 16.44C9.12 16.44 8.7 16.02 8.7 15.52C8.7 15.02 9.12 14.6 9.62 14.6C10.12 14.6 10.54 15.02 10.54 15.52C10.54 16.02 10.12 16.44 9.62 16.44ZM11.34 14.8H14.88V16.24H11.34V14.8Z" />
    </SvgIcon>
  );
});
